"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.colSizes = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["children", "className", "element", "emptyLarge", "emptyMedium", "emptySmall", "large", "medium", "size", "small"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var colSizes = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
exports.colSizes = colSizes;

var Col = function Col(_ref) {
  var _classNames;

  var children = _ref.children,
      className = _ref.className,
      _ref$element = _ref.element,
      Component = _ref$element === void 0 ? "div" : _ref$element,
      emptyLarge = _ref.emptyLarge,
      emptyMedium = _ref.emptyMedium,
      emptySmall = _ref.emptySmall,
      large = _ref.large,
      medium = _ref.medium,
      size = _ref.size,
      small = _ref.small,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(Component, _extends({
    className: (0, _classnames.default)(className, "col-".concat(size), (_classNames = {}, _defineProperty(_classNames, "col-small-".concat(small), !!small), _defineProperty(_classNames, "col-medium-".concat(medium), !!medium), _defineProperty(_classNames, "col-large-".concat(large), !!large), _defineProperty(_classNames, "col-start-small-".concat(emptySmall), !!emptySmall), _defineProperty(_classNames, "col-start-medium-".concat(emptyMedium), !!emptyMedium), _defineProperty(_classNames, "col-start-large-".concat(emptyLarge), !!emptyLarge), _classNames))
  }, props), children);
};

var _default = Col;
exports.default = _default;